export const topics = [
    { _id: "beginner", name: "Basic Concepts" },
    { _id: "rm", name: "Relational Model" },
    { _id: "fo", name: "File Organization" },
    { _id: "nosql", name: "NoSQL" },
    { _id: "sql", name: "SQL" },
];
